
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/bondiatv",
      function () {
        return require("private-next-pages/corporatiu/bondiatv/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/bondiatv"])
      });
    }
  